import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, Router } from '@angular/router';
import { ServiceFeatures } from '../models/serviceFeatures';
import { SessionService } from '../services/session.service';

export const demoGuard = (route: ActivatedRouteSnapshot) => {
	const redirect: Array<string> = route.data?.redirect || [''];
	const sessionService: SessionService = inject(SessionService);
	const router: Router = inject(Router);

	if (!sessionService.hasFeature(ServiceFeatures.Demo)) {
		return new RedirectCommand(
			router.createUrlTree(sessionService.getLink(redirect)),
			{ replaceUrl: true, skipLocationChange: false }
		);
	} else {
		return true;
	}
}
